import { gql } from 'graphql-request'

export const CREATE_CAMPAIGN = gql`
  mutation CreateCampaign($createCampaignInput: CreateCampaignInput!) {
    createCampaign(createCampaignInput: $createCampaignInput) {
      id
    }
  }
`
